import { getApiUrl } from '../utils/apiUrl';

const API_URL = getApiUrl();

const buildOptions = (body) => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(body),
});

export const register = async (payload) => {
  const response = await fetch(`${API_URL}/auth/register`, buildOptions(payload));
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Registration failed' }));
    throw new Error(errorData.message || 'Registration failed');
  }
  return response.json();
};

export const login = async (payload) => {
  const response = await fetch(`${API_URL}/auth/login`, buildOptions(payload));
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Login failed' }));
    throw new Error(errorData.message || 'Login failed');
  }
  return response.json();
};
